import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetPolitica() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getPolitica = useCallback(
        () =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Politica/pendencias`,
                method: 'GET',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getPolitica,
    };
}
